/**
 * 审计日志详情弹窗：基本信息、错误信息、操作前后的值、操作详情、User Agent
 */
import { Alert, Descriptions, Modal, Tag, Typography } from 'antd'
import { actionColor, actionLabel, formatAuditTime } from './constants'
import type { AuditLog } from './hooks'
import styles from './AuditLogsPage.module.css'

function JsonSection({ title, value }: Readonly<{ title: string; value: unknown }>) {
  if (!value) return null
  return (
    <div className={styles.detailSection}>
      <Typography.Title level={5}>{title}</Typography.Title>
      <pre className={styles.json}>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}

export function AuditLogDetailModal({ log, onClose }: Readonly<{ log: AuditLog | null; onClose: () => void }>) {
  return (
    <Modal open={log !== null} title="操作详情" width={800} footer={null} onCancel={onClose}>
      {log && (
        <div>
          <Descriptions column={2} bordered size="small">
            <Descriptions.Item label="日志ID">{log.id}</Descriptions.Item>
            <Descriptions.Item label="操作时间">{formatAuditTime(log.created_at)}</Descriptions.Item>
            <Descriptions.Item label="管理员">
              {log.admin_name} ({log.admin_username})
            </Descriptions.Item>
            <Descriptions.Item label="操作类型">
              <Tag color={actionColor(log.action)}>{actionLabel(log.action)}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="目标类型">{log.target_type || '-'}</Descriptions.Item>
            <Descriptions.Item label="目标ID">{log.target_id || '-'}</Descriptions.Item>
            <Descriptions.Item label="状态">
              <Tag color={log.success ? 'success' : 'error'}>{log.success ? '成功' : '失败'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="IP地址">{log.ip_address || '-'}</Descriptions.Item>
            {log.error_message && (
              <Descriptions.Item label="错误信息" span={2}>
                <Alert type="error" showIcon title={log.error_message} />
              </Descriptions.Item>
            )}
          </Descriptions>

          <JsonSection title="操作前的值" value={log.old_values} />
          <JsonSection title="操作后的值" value={log.new_values} />
          <JsonSection title="操作详情" value={log.details} />
          {log.user_agent && (
            <div className={styles.detailSection}>
              <Typography.Title level={5}>User Agent</Typography.Title>
              <Typography.Text type="secondary" className={styles.breakAll}>
                {log.user_agent}
              </Typography.Text>
            </div>
          )}
        </div>
      )}
    </Modal>
  )
}
